import { ApiError } from "@/services/api";

export type FormErrors = {
  /** First message per field, keyed by the API field name. */
  fields: Record<string, string>;
  /** Form-level message (non-field error, throttling, network, server). */
  message: string | null;
};

const GENERIC_FAILURE = "Something went wrong. Try again.";

/**
 * Turn an API failure into something a form can render.
 * DRF validation errors look like {"field": ["msg"], "detail": "msg", "non_field_errors": ["msg"]}.
 */
export function toFormErrors(error: unknown): FormErrors {
  if (!(error instanceof ApiError)) {
    return { fields: {}, message: GENERIC_FAILURE };
  }

  const fields: Record<string, string> = {};
  let message: string | null = null;

  if (error.status === 400 && error.data && typeof error.data === "object") {
    for (const [key, value] of Object.entries(error.data as Record<string, unknown>)) {
      const first: unknown = Array.isArray(value) ? value[0] : value;
      if (typeof first !== "string") continue;
      if (key === "detail" || key === "non_field_errors") {
        message = first;
      } else {
        fields[key] = first;
      }
    }
    if (!message && Object.keys(fields).length === 0) {
      message = error.message;
    }
    return { fields, message };
  }

  return { fields, message: error.message };
}